import React from 'react';
import ReactDOM from 'react-dom';

import ProgramGuide from './components/ProgramGuide';

import './styles.scss';

const Root = () => (
  <div className="AppContainer">
    <ProgramGuide />
  </div>
);

ReactDOM.render(<Root/>, document.getElementById('telemundo-program-guide'));
